import { defineMessages } from "react-intl"

const dataTableMessages = defineMessages({
  bodyNoMatch: {
    defaultMessage: "No results found",
    description: "No records found",
    id: "datatable.body.nomatch"
  },
  bodyToolTip: {
    defaultMessage: "Sort",
    description: "Tooltip on column headers",
    id: "datatable.body.sort"
  },
  bodyColumnHeaderTooltip: {
    defaultMessage: "Sort for {label}",
    description: "Tooltip on column headers",
    id: "datatable.body.header.tooltip"
  },

  paginationNext: {
    defaultMessage: "Next page",
    description: "Next page (tooltip)",
    id: "datatable.pagination.next"
  },
  paginationPrevious: {
    defaultMessage: "Previous page",
    description: "Previous page (tooltip)",
    id: "datatable.pagination.previous"
  },
  paginationRowsPerPage: {
    defaultMessage: "Rows per page:",
    description: "Rows per page:",
    id: "datatable.pagination.rowsperpage"
  },
  paginationDisplayRows: {
    defaultMessage: "of",
    description: "Page 1-5 of 14",
    id: "datatable.pagination.of"
  },

  toolbarSearch: {
    defaultMessage: "Search",
    description: "Tooltip search action",
    id: "datatable.toolbar.search"
  },
  toolbarDownloadCsv: {
    defaultMessage: "Download CSV",
    description: "Tooltip download csv action",
    id: "datatable.toolbar.download.csv"
  },
  toolbarPrint: {
    defaultMessage: "Print",
    description: "Tooltip on print action",
    id: "datatable.toolbar.print"
  },
  toolbarViewColumns: {
    defaultMessage: "View Columns",
    description: "Tooltip on view columns action",
    id: "datatable.toolbar.view.columns"
  },
  toolbarFilterTable: {
    defaultMessage: "Filter Table",
    description: "Tooltip on filter action",
    id: "datatable.toolbar.filter"
  },

  filterAll: {
    defaultMessage: "All",
    description: "Filter window - All button",
    id: "datatable.filter.all"
  },
  filterTitle: {
    defaultMessage: "FILTERS",
    description: "Filter window - Title",
    id: "datatable.filter.title"
  },
  filterReset: {
    defaultMessage: "RESET",
    description: "Filter window - Reset button",
    id: "datatable.filter.reset"
  },

  viewColumnsTitle: {
    defaultMessage: "Show Columns",
    description: "Show Columns",
    id: "datatable.view.columns.title"
  },
  viewColumnsTitleAria: {
    defaultMessage: "Show/Hide Table Columns",
    description: "Show/Hide Table Columns",
    id: "datatable.view.columns.title.aria"
  },

  selectedRowsText: {
    defaultMessage: "row(s) selected",
    description: "row(s) selected",
    id: "datatable.selected.rows.text"
  },
  selectedRowsDelete: {
    defaultMessage: "Delete",
    description: "Delete",
    id: "datatable.selected.rows.delete"
  },
  selectedRowsDeleteAria: {
    defaultMessage: "Delete Selected Rows",
    description: "Delete Selected Rows",
    id: "datatable.selected.rows.delete.aria"
  }
})

export const dialogMessages = defineMessages({
  confirmGroupAction: {
    defaultMessage: "Confirm group action",
    id: "dialog.confirm.group.action"
  },
  dirtyGoBack: {
    id: "dialog.dirty.goback",
    defaultMessage:
      "Be aware that some unsaved modifications are in progress. Do you really want to quit without saving ?"
  },
  dirtyTitle: {
    id: "dialog.dirty.title",
    defaultMessage: "Unsaved modifications"
  },
  relaunchConfirm: {
    id: "dialog.relaunch.confirm",
    defaultMessage:
      "Do you want to republish the form? A follow-up email will be sent to your customer."
  },
  forgotPasswordSuccess: {
    id: "action.forgotpassword.sentmail",
    defaultMessage: "An email was sent to {email} if an account exists."
  },
  forgotPasswordInvalidEmail: {
    id: "action.forgotpassword.invalidemail",
    defaultMessage: "Invalid email"
  },
  forgotPasswordError: {
    id: "action.forgotpassword.invalidrequest",
    defaultMessage: "Invalid request"
  },
  confirmMessage: {
    defaultMessage: "Are you sure ?",
    id: "dialog.confirm.message"
  }
})

export const words = defineMessages({
  variablesForMail: {
    id: "word.template.variables",
    defaultMessage: "Variables for emails"
  },
  from: {
    id: "word.template.mail",
    defaultMessage: "From"
  },
  cc: {
    id: "word.cc",
    defaultMessage: "CC"
  },
  titleMail: {
    id: "word.template.title.mail",
    defaultMessage: "Email title"
  },
  bodyMail: {
    id: "word.template.body.mail",
    defaultMessage: "Email body"
  },
  fileName: {
    id: "word.resource.graphic.file.name",
    defaultMessage: "File name"
  },
  file: {
    id: "word.resource.graphic.file",
    defaultMessage: "File"
  },
  testSendMail: {
    id: "word.test.send.mail",
    defaultMessage: "Test sending mail"
  },
  identifier: {
    id: "word.identifier",
    defaultMessage: "Identifier"
  },
  submit: {
    id: "word.submit",
    defaultMessage: "Submit"
  },
  search: {
    id: "word.search",
    defaultMessage: "Search"
  },
  information: {
    id: "word.information",
    defaultMessage: "Information"
  },
  error: {
    id: "word.error",
    defaultMessage: "Error"
  },
  add: {
    id: "word.add",
    defaultMessage: "Add"
  },
  edit: {
    id: "word.edit",
    defaultMessage: "Edit"
  },
  view: {
    id: "word.view",
    defaultMessage: "View"
  },
  disable: {
    id: "word.disable",
    defaultMessage: "Disable"
  },
  delete: {
    id: "word.delete",
    defaultMessage: "Delete"
  },
  duplicate: {
    id: "word.duplicate",
    defaultMessage: "Duplicate"
  },
  publish: {
    id: "word.publish",
    defaultMessage: "Publish"
  },
  ignore: {
    id: "word.ignore",
    defaultMessage: "Ignore"
  },
  copy: {
    id: "word.copy",
    defaultMessage: "Copy"
  },
  drag: {
    id: "word.drag",
    defaultMessage: "Drag"
  },
  save: {
    id: "word.save",
    defaultMessage: "Save"
  },
  autosave: {
    id: "word.save.auto",
    defaultMessage: "Save automatically"
  },
  deleteSelection: {
    id: "word.deleteSelection",
    defaultMessage: "Delete selection"
  },
  publishSelection: {
    id: "word.publish.selection",
    defaultMessage: "Publish selection"
  },
  yes: {
    id: "word.yes",
    defaultMessage: "Yes"
  },
  no: {
    id: "word.no",
    defaultMessage: "No"
  },
  name: {
    id: "word.name",
    defaultMessage: "Name"
  },
  category: {
    id: "word.category",
    defaultMessage: "Category"
  },
  corporation: {
    id: "word.corporation",
    defaultMessage: "Corporation"
  },
  lastInvitationSentAt: {
    id: "word.lastInvitationSentAt",
    defaultMessage: "last invitation sent at"
  },
  senderUser: {
    id: "word.senderUser",
    defaultMessage: "Sender user"
  },
  allContacts: {
    id: "word.allContacts",
    defaultMessage: "All contacts"
  },
  notInvited: {
    id: "word.notInvited",
    defaultMessage: "Not invited"
  },
  inProgress: {
    id: "word.inProgress",
    defaultMessage: "In progress"
  },
  expired: {
    id: "word.expired",
    defaultMessage: "Expired"
  },
  invitationExpired: {
    id: "word.invitationExpired",
    defaultMessage: "Invitation expired"
  },
  accountCreated: {
    id: "word.accountCreated",
    defaultMessage: "Account created"
  },
  download: {
    id: "word.download",
    defaultMessage: "Download"
  },
  sign: {
    id: "word.sign",
    defaultMessage: "Sign"
  },
  return: {
    id: "word.return",
    defaultMessage: "Return"
  },
  required: {
    id: "word.required",
    defaultMessage: "Field above is mandatory"
  },
  email: {
    id: "word.email",
    defaultMessage: "Email"
  },
  senderEmail: {
    id: "word.senderEmail",
    defaultMessage: "Recipient email"
  },
  server: {
    id: "word.server",
    defaultMessage: "Server"
  },
  port: {
    id: "word.port",
    defaultMessage: "Port"
  },
  account_user: {
    id: "word.account.user",
    defaultMessage: "Account / User"
  },
  method: {
    id: "word.method",
    defaultMessage: "Method"
  },
  password: {
    id: "word.password",
    defaultMessage: "Password"
  },
  min_version: {
    id: "word.min.version",
    defaultMessage: "Minimum version"
  },
  max_version: {
    id: "word.max.version",
    defaultMessage: "Maximum version"
  },
  max_instance: {
    id: "word.max.instance",
    defaultMessage: "Maximum instances in parallel"
  },
  max_mails_sending: {
    id: "word.max.mails_sending",
    defaultMessage: "Maximum emails sent"
  },
  service_id: {
    id: "word.service.id",
    defaultMessage: "Service ID"
  },
  service_key: {
    id: "word.service.key",
    defaultMessage: "Service Key"
  },
  access_token: {
    id: "word.access.token",
    defaultMessage: "Access token"
  },
  refresh_token: {
    id: "word.refresh.token",
    defaultMessage: "Refresh token"
  },
  access_url: {
    id: "word.url.to.refresh.token",
    defaultMessage: "URL to refresh token"
  },
  refresh_automatic_token: {
    id: "word.refresh.automatic.token",
    defaultMessage: "Automatic token refresh"
  },
  status: {
    id: "word.status",
    defaultMessage: "Status"
  },
  users: {
    id: "word.users",
    defaultMessage: "Users"
  },
  widgets: {
    id: "word.widgets",
    defaultMessage: "Widgets"
  },
  firstName: {
    id: "word.firstname",
    defaultMessage: "First name"
  },
  lastName: {
    id: "word.lastname",
    defaultMessage: "Last name"
  },
  none: {
    id: "word.none",
    defaultMessage: "None"
  },
  noData: {
    id: "word.noData",
    defaultMessage: "No data found"
  },
  relaunch: {
    id: "word.relaunch",
    defaultMessage: "Relaunch"
  },
  basket: {
    id: "word.basket",
    defaultMessage: "Basket"
  },
  mode: {
    id: "word.mode",
    defaultMessage: "Mode"
  },
  form: {
    id: "word.form",
    defaultMessage: "Form"
  },
  forms: {
    id: "word.forms",
    defaultMessage: "Forms"
  },
  simple: {
    id: "word.simple",
    defaultMessage: "Simple"
  },
  periodic: {
    id: "word.periodic",
    defaultMessage: "Periodic"
  },
  persistent: {
    id: "word.persistent",
    defaultMessage: "Persistent"
  },
  daily: {
    id: "word.daily",
    defaultMessage: "Daily"
  },
  weekly: {
    id: "word.weekly",
    defaultMessage: "Weekly"
  },
  monthly: {
    id: "word.monthly",
    defaultMessage: "Monthly"
  },
  quarterly: {
    id: "word.quarterly",
    defaultMessage: "Quarterly"
  },
  semiYearly: {
    id: "word.semi_yearly",
    defaultMessage: "Semi-yearly"
  },
  yearly: {
    id: "word.yearly",
    defaultMessage: "Yearly"
  },
  account_statement: {
    id: "word.account_statement",
    defaultMessage: "Account statement"
  },
  account_statements: {
    id: "word.account_statements",
    defaultMessage: "Account statements"
  },
  example: {
    id: "word.example",
    defaultMessage: "Example"
  },
  close: {
    id: "word.close",
    defaultMessage: "Close"
  },
  cancel: {
    id: "word.cancel",
    defaultMessage: "Cancel"
  },
  expand: {
    id: "word.expand",
    defaultMessage: "Expand"
  },
  collapse: {
    id: "word.collapse",
    defaultMessage: "Collapse"
  },
  remainingTries: {
    id: "word.remainingTries",
    defaultMessage: "Remaining tries"
  },
  loading: {
    id: "word.loading",
    defaultMessage: "Loading..."
  },
  userProfile: {
    id: "word.userprofile",
    defaultMessage: "User profile"
  },
  transferSelectedItems: {
    id: "word.transfer.selected.items",
    defaultMessage: "{selected}/{total} selected"
  },
  transferAvailableTitle: {
    id: "word.transfer.available.title",
    defaultMessage: "Available values"
  },
  transferValuesTitle: {
    id: "word.transfer.selection.title",
    defaultMessage: "Selected values"
  },
  help: {
    id: "word.help",
    defaultMessage: "Help"
  },
  jumpId: {
    id: "word.jumpID",
    defaultMessage: "JUMP ID"
  },
  webportalId: {
    id: "word.webportalID",
    defaultMessage: "Webportal ID"
  },
  portfolio: {
    id: "word.portfolio",
    defaultMessage: "Portfolio"
  },
  type: {
    id: "word.type",
    defaultMessage: "Type"
  },
  typeService: {
    id: "word.type",
    defaultMessage: "Type"
  },
  minimum: {
    id: "word.minimum",
    defaultMessage: "Minimum"
  },
  maximum: {
    id: "word.maximum",
    defaultMessage: "Maximum"
  },
  noResultsFound: {
    id: "word.noResultsFound",
    defaultMessage: "No results found"
  },
  currency: {
    id: "word.currency",
    defaultMessage: "Currency"
  },
  back: {
    id: "word.back",
    defaultMessage: "Back"
  },
  next: {
    id: "word.next",
    defaultMessage: "Next"
  },
  skip: {
    id: "word.skip",
    defaultMessage: "Skip"
  }
})

export const formElements = defineMessages({
  address: {
    id: "form.element.address",
    defaultMessage: "Address"
  },
  city: {
    id: "form.element.address.city",
    defaultMessage: "City"
  },
  postalCode: {
    id: "form.element.address.postalCode",
    defaultMessage: "Postal Code"
  },
  country: {
    id: "form.element.address.country",
    defaultMessage: "Country"
  }
})

export const formsAction = defineMessages({
  addElement: {
    id: "form.action.add",
    defaultMessage: "Add form field"
  },
  up: {
    id: "form.action.up",
    defaultMessage: "Move up"
  },
  down: {
    id: "form.action.down",
    defaultMessage: "Move down"
  },
  defaultFormSelectLabel: {
    id: "form.element.scrollingList.default",
    defaultMessage: "Please select:"
  },
  addNewElementToRow: {
    id: "form.action.addNewElementToRow",
    defaultMessage: "Add an element to this row"
  }
})

export const widgetsMessages = defineMessages({
  toggleWidgetPreviewButton: {
    defaultMessage: "Toggle template/preview",
    id: "menu.assetManagementPages.toggleButton"
  }
})

export default dataTableMessages
